import { Box, Alert } from "@mui/material";
import LoadingScreen from "../../progress/loading-screen";
import useTemplates from "../hooks/use-templates";
import TemplateTable from "./template-table";
import TemplateForm from "./template-form";
import TemplateConfirmationDialog from "./template-confirmation-dialog";
import useTemplateConfiguration from "../hooks/use-template-configuration";

const TemplateConfiguration = () => {
  const { templates, isLoading, error, mutate } = useTemplates();
  const {
    selectedTemplate,
    formData,
    isSaving,
    showConfirmDialog,
    pendingValidatorValue,
    availableValidCharacters,
    isLoadingValidCharacters,
    setFormData,
    handleTemplateChange,
    handleToggleValidator,
    handleToggleValidatorFromTable,
    handleChangeTemplate,
    handleConfirmToggle,
    handleCancelToggle,
    handleSave,
    handleSaveValidCharacters,
  } = useTemplateConfiguration(mutate);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <Alert severity="error">
        Failed to load templates. Please try again later.
      </Alert>
    );
  }

  return (
    <Box>
      {selectedTemplate ? (
        <TemplateForm
          selectedTemplate={selectedTemplate}
          formData={formData}
          isSaving={isSaving}
          availableValidCharacters={availableValidCharacters}
          isLoadingValidCharacters={isLoadingValidCharacters}
          onFormDataChange={setFormData}
          onToggleValidator={handleToggleValidator}
          onSave={handleSave}
          onCancel={handleChangeTemplate}
          onSaveValidCharacters={handleSaveValidCharacters}
        />
      ) : (
        <TemplateTable
          templates={templates || []}
          onTemplateSelect={(template) =>
            handleTemplateChange(
              null as unknown as React.SyntheticEvent,
              template,
            )
          }
          onToggleValidator={handleToggleValidatorFromTable}
          isSaving={isSaving}
        />
      )}

      <TemplateConfirmationDialog
        open={showConfirmDialog}
        isActivating={pendingValidatorValue}
        isSaving={isSaving}
        onConfirm={handleConfirmToggle}
        onCancel={handleCancelToggle}
      />
    </Box>
  );
};

export default TemplateConfiguration;
